export default "__VITE_ASSET__BfDv6bpC__"